// extracted by mini-css-extract-plugin
export var contactInfo = "contact-info-module--contact-info--1cfD_";
export var list = "contact-info-module--list--3P5XE";
export var icon = "contact-info-module--icon--2mo1v";